import axios from 'axios'
import store from '../store/store'

/* eslint-disable no-console, no-irregular-whitespace */
export default {
  send: function(path, args) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + path, args)
      .then(r => {
        if (r.status !== 200) {
          store.commit('openToast', {
            text: 'Your request was unsuccessful, please contact support at {{PH}}',
            type: 'error'
          })

          return
	}
	
	if (!r.data.Success) {
          store.commit('openToast', {
            text: r.data.Message || 'Unknown API Error',
            type: 'error'
          })

          return
	}

        return r
      })
      .catch(error => {
        store.commit('openToast', {
          text: 'Communication Error: ' + error,
          type: 'error'
        })

        console.log('Communication Error: ', error)
      })
  }
}
